export async function resizeImageBlob(
  blob: Blob,
  targetWidth: number,
  targetHeight: number
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const img = new Image();

    // Создаем URL для изображения из Blob
    img.src = URL.createObjectURL(blob);

    img.onload = () => {
      // Создаем canvas и задаем размеры
      const canvas = document.createElement('canvas');
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      // Рендерим изображение на canvas с новыми размерами
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Failed to get canvas context'));
        return;
      }
      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

      // Преобразуем canvas обратно в Blob
      canvas.toBlob(resizedBlob => {
        URL.revokeObjectURL(img.src); // Освобождаем память
        if (resizedBlob) {
          resolve(resizedBlob);
        } else {
          reject(new Error('Failed to create blob from canvas'));
        }
      }, blob.type); // Сохраняем исходный формат
    };

    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      reject(new Error('Failed to load image'));
    };
  });
}
